import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import intl from "react-intl-universal";

import userRest from "../../../rest/userRest";

import { Button } from "../../components/Button";
import { Dialog } from "../../containers/Dialog";
import { PdfPage } from "../../components/PdfPage";
import { DialogBody } from "../../containers/DialogBody";
import { UserContext } from "../../contexts/UserContext";
import { DialogFooter } from "../../containers/DialogFooter";

const DialogBodyStyle = styled.div`
    height: 100%;
    min-height: 1500px;
`;

const DialogFooterStyle = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const AgreementDialog = () => {

    const [show, setShow] = useState(false);

    const userContext = useContext(UserContext);
    const { user } = userContext;

    useEffect(() => {
        if (user && user.agreementAccepted === false) {
            setShow(true);
        }
    }, [user]);

    const onAccept = async () => {
        await userRest.acceptAgreement();
        await userContext.refresh();
        setShow(false);
    };

    return (
        <>
            {show &&
                <Dialog
                    width="800px"
                    closeIcon={false}
                    title={intl.get("navigation.agreement")}
                    onClose={() => setShow(false)}>
                    <DialogBody>
                        <DialogBodyStyle>
                            <PdfPage url="/rest/resource/document/agreement.pdf" />
                        </DialogBodyStyle>
                    </DialogBody>
                    <DialogFooter>
                        <DialogFooterStyle>
                            <Button
                                onClick={() => onAccept()}
                                value={intl.get("agreement.accept")} />
                        </DialogFooterStyle>
                    </DialogFooter>
                </Dialog>
            }
        </>
    );
};
